export default __webpack_public_path__ + "assets/366838c525cb1f7e0a1ad599be298e52.png";